import { useEffect, useState } from "react";
import React from "react";
import { Modal } from "react-bootstrap";
import "../assets/styles/PoleInformation.scss";

const ConfirmPoleStatus: React.FC<propTypes> = (props: propTypes) => {
    const {UndoUpdatedPoleStatus,confirmUndoReplacePole, status,  ...rest} = props;

    const [flag, setFlag] = useState(false);
    const confirmationMessage = status.repairId ? "Do you want to remove repaired status?" : "Do you want to undo Pole Replacement?";

    useEffect(() => {
        if (window.innerWidth < 991) {
			setFlag(true);
		}
    }, []);


    return (
        <Modal {...rest} data-testid="ConfirmPoleStatusModal" centered={flag === true}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <h5 className="modal-title" id="staticBackdropLabel">Confirmation</h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <label>{confirmationMessage}</label>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" data-testid="cancle-btn" className="btn btn-secondary" onClick={props.onHide}>Cancel</button>
                <button type="button" data-testid="submit-btn" className="btn btn-primary"
                    onClick={() => {
                        if (status.repairId) {
                            UndoUpdatedPoleStatus(status.repairId); // Call the update API
                        } else {
                          confirmUndoReplacePole(); // Show the undo confirmation modal
                        }
                    }}
                >
                    Yes
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export type propTypes = {
    status:{ isResolved: boolean, repairId: number },
    UndoUpdatedPoleStatus: (repairId) => void,
    confirmUndoReplacePole: () => void,
    onHide: () => void,
    show: boolean
};

export default ConfirmPoleStatus;